import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "grid grid-cols-4 gap-4 px-4" }
const _hoisted_2 = { class: "col-span-1 lg:col-span-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "list icon"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "col-span-1" }
const _hoisted_6 = { class: "col-span-1" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "col-span-1" }
const _hoisted_9 = { class: "font-medium" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "list icon"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "col-span-1 lg:col-span-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "list icon"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "col-span-1 lg:col-span-1" }
const _hoisted_16 = { class: "col-span-2" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = { class: "col-span-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "list icon"
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "col-span-1 lg:col-span-1" }
const _hoisted_22 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_23 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_24 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_30 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_31 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]

import { // language
		useI18n
	} from 'vue-i18n'
	
	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { // vue
		inject,
		ref
	} from 'vue'

	
	const __default__ = { name: 'TransportationDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const {t} = useI18n()

	const store = localesStore()

	const selectedOption = ref({})
	const transportationDetailsModal = ref<{open: boolean}>({open: false})

	const modalBreadcrumb = [
		{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
		{label: props?.job?.fieldData?.name_bride_groom_display, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
		{label: store.getLabel('185'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#transportation' }}, // scenes
	]

	const modalTitle = ref()
	const mediaLoading = ref(false)
	const fetchS3File: any = inject('fetchS3File')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	async function openModalDetails(title: string, pictureS3Json: string, videoS3Json: string) {
		modalTitle.value = title
		transportationDetailsModal.value.open = true
		try {
			mediaLoading.value = true
			signedUrlPhoto.value = await fetchS3File(pictureS3Json)
			signedUrlVideo.value = await fetchS3File(videoS3Json)
		}
		catch(e) {
			console.error(e)
		}
		finally {
			mediaLoading.value = false
		}
	}

	function hasPicture(row: any) {
		return row?.['job__JOBS_OPTIONS__jobID::picture']
	}

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_data_display, {
          loading: __props.loading,
          label: _unref(store).getLabel('662'),
          value: __props.job?.fieldData?.['job__CONTACTS__locationID::train_station_name_display'] || '—'
        }, null, 8, ["loading", "label", "value"]),
        _createElementVNode("div", {
          class: _normalizeClass([[__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPictureTrain'] ? 'linked-icon' : 'grayed-icon'], "h-6 w-6 cursor-pointer"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModalDetails(__props.job?.fieldData?.['job__CONTACTS__locationID::train_station_name_display'],
					__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPictureTrain'], 
					__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONVideoTrain'])))
        }, _hoisted_4, 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_data_display, {
          loading: __props.loading,
          label: _unref(store).getLabel('381'),
          value: __props.job?.fieldData?.['job__CONTACTS__locationID::train_station_walk'] || '—'
        }, null, 8, ["loading", "label", "value"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_data_display, null, {
          custom: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.['job__CONTACTS__locationID::train_station_taxi']}])
            }, [
              (__props.job?.fieldData?.['job__CONTACTS__locationID::train_station_taxi'])
                ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                    key: 0,
                    class: "h-5 w-5"
                  }))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5"
                  })),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(store).getLabel('380')), 1)
            ], 2)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_data_display, null, {
          custom: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.['job__CONTACTS__locationID::pick_up_display']}])
            }, [
              (__props.job?.fieldData?.['job__CONTACTS__locationID::pick_up_display'])
                ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                    key: 0,
                    class: "h-5 w-5"
                  }))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5"
                  })),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(store).getLabel('22')), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([[__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPicturePickup'] ? 'linked-icon' : 'grayed-icon '], "h-6 w-6 cursor-pointer"]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openModalDetails(_unref(store).getLabel('22'),
							__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPicturePickup'],
							__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONVideoPickup'])))
            }, _hoisted_11, 2)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_data_display, {
          loading: __props.loading,
          label: _unref(store).getLabel('661'),
          value: __props.job?.fieldData?.['job__CONTACTS__locationID::train_station_name_other_display'] || '—'
        }, null, 8, ["loading", "label", "value"]),
        _createElementVNode("div", {
          class: _normalizeClass([[__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPictureTrainOther'] ? 'linked-icon' : 'grayed-icon '], "h-6 w-6 cursor-pointer"]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (openModalDetails(__props.job?.fieldData?.['job__CONTACTS__locationID::train_station_name_other_display'],
					__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPictureTrainOther'],
					__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONVideoTrainOther'])))
        }, _hoisted_14, 2)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_data_display, {
          loading: __props.loading,
          label: _unref(store).getLabel('381'),
          value: __props.job?.fieldData?.['job__CONTACTS__locationID::train_station_walk_other'] || '—'
        }, null, 8, ["loading", "label", "value"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_data_display, null, {
          custom: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !__props.job?.fieldData?.['job__CONTACTS__locationID::train_station_taxi_other']}])
            }, [
              (__props.job?.fieldData?.['job__CONTACTS__locationID::train_station_taxi_other'])
                ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                    key: 0,
                    class: "h-5 w-5"
                  }))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5"
                  })),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(store).getLabel('380')), 1)
            ], 2)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_data_display, {
          loading: __props.loading,
          label: _unref(store).getLabel('660'),
          value: __props.job?.fieldData?.['job__CONTACTS__locationID::bus_stop_name_display'] || '—'
        }, null, 8, ["loading", "label", "value"]),
        _createElementVNode("div", {
          class: _normalizeClass([[__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPictureBus'] ? 'linked-icon' : 'grayed-icon '], "h-6 w-6 cursor-pointer"]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (openModalDetails(__props.job?.fieldData?.['job__CONTACTS__locationID::bus_stop_name_display'],
					__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONPictureBus'],
					__props.job?.fieldData?.['job__contacts__CONTACTS_INFO__contactsID::s3JSONVideoBus'])))
        }, _hoisted_20, 2)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_data_display, {
          loading: __props.loading,
          label: _unref(store).getLabel('381'),
          value: __props.job?.fieldData?.['job__CONTACTS__locationID::bus_stop_walk'] || '—'
        }, null, 8, ["loading", "label", "value"])
      ])
    ]),
    _createVNode(_component_tw_modal, {
      title: modalTitle.value,
      breadcrumb: modalBreadcrumb,
      ref_key: "transportationDetailsModal",
      ref: transportationDetailsModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_data_display, {
              label: _unref(store).getLabel('293')
            }, {
              custom: _withCtx(() => [
                (mediaLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                  : (signedUrlPhoto.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "object-cover w-96 h-75 rounded-md",
                        src: signedUrlPhoto.value
                      }, null, 8, _hoisted_25))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_data_display, {
              label: _unref(store).getLabel('294')
            }, {
              custom: _withCtx(() => [
                (mediaLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                  : (signedUrlVideo.value)
                    ? (_openBlock(), _createElementBlock("video", _hoisted_31, [
                        _createElementVNode("source", {
                          type: "video/mp4",
                          src: signedUrlVideo.value
                        }, null, 8, _hoisted_32)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}
}

})